import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Tooltip,
} from '@material-ui/core';
import { HomeOutlined as HomeOutlinedIcon } from '@material-ui/icons';
import EditPropertiesForm from '../forms/EditPropertiesForm';

const useStyles = makeStyles((theme) => ({
  submitButton: {
    borderRadius: 50,
    minWidth: 0,
    width: 'auto',
    padding: 2,
    margin: theme.spacing(0, 0.5),
    position: 'relative',
  },
}));

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

// eslint-disable-next-line no-unused-vars
export default function EditPropertiesModal({ companyId, clientId }) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          Edit Properties
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            To edit properties, please fill the following fields:
          </DialogContentText>
          <EditPropertiesForm companyId={companyId} clientId={clientId} callback={handleClose} open={open} />
        </DialogContent>
      </Dialog>
      <Tooltip title="Edit Properties">
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.submitButton}
          onClick={handleOpen}
        >
          <HomeOutlinedIcon fontSize="small" />
        </Button>
      </Tooltip>
    </>
  );
}
